import { render, staticRenderFns } from "./StatsElectricTable.vue?vue&type=template&id=5339f2b1&scoped=true&"
import script from "./StatsElectricTable.vue?vue&type=script&lang=ts&"
export * from "./StatsElectricTable.vue?vue&type=script&lang=ts&"
import style0 from "./StatsElectricTable.vue?vue&type=style&index=0&id=5339f2b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5339f2b1",
  null
  
)

export default component.exports